import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8403e654"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid message-container-align" }

import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'InvalidRequest',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(t)("form.invalidrequest")), 1)
  ]))
}
}

})